import React, { Component } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Box } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import Measure from 'react-measure';

const loadImage = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

// Styled component
const StyledImage = styled(Box)`
  width: 100%;
  height: ${(props) => props.height}px;
  background: url(${(props) => props.src});
  background-color: ${(props) => props.theme.colors.gray3};
  background-size: cover;
  background-position: center;
  ${(props) =>
    props.disableFade
        ? ''
        : css`
          animation: ${loadImage} 2.5s ease;
        `};
`;

class ImageCarousel extends Component {
  constructor (props) {
    super(props);
    this.state = {
      currentImage: 0,
      imageDimensions: {
        width: -1,
        height: -1,
      },
    };
  }

  scrollImages = () => {
    const { images } = this.props;
    if (!images.length) {
      return;
    }
    this.scrollInterval = setInterval(() => {
      const { currentImage } = this.state;

      this.setState({
        currentImage: (currentImage + 1) % images.length,
      });
    }, 500);
  };

  cancelScroll = () => {
    clearInterval(this.scrollInterval);
  };

  render () {
    const { images, disableFade } = this.props;
    const { currentImage, imageDimensions } = this.state;

    return (
        <Measure
            bounds
            onResize={(contentRect) => {
              this.setState({ imageDimensions: contentRect.bounds });
            }}
        >
          {({ measureRef }) => (
              <span ref={measureRef}>
            {images && (
                <StyledImage
                    as={Box} // Use `as` prop to dynamically render `Box`
                    disableFade={disableFade}
                    onMouseEnter={this.scrollImages}
                    onMouseLeave={this.cancelScroll}
                    src={images[currentImage]}
                    height={imageDimensions.width}
                    alt="Content Carousel Image"
                />
            )}
          </span>
          )}
        </Measure>
    );
  }
}

ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  disableFade: PropTypes.bool,
};

export default ImageCarousel;